import {fetchLeadersFailed} from "modules/actions/leaders";
import {RequestState} from "modules/enums";
import {createReducer} from "redux-act";
import {
	fetchLeaderboardSuccess,
	fetchLeaderboard,
	IUserProfile,
	fetchLeaderProfile,
	fetchLeaderProfileSuccess,
	fetchLeaderProfileFailed,
	clearFetchedPagesLeaderboards,
	clearLeaderboard,
	showUpdateNotice,
} from "modules/actions/leaderboards";
import {uniq} from "lodash";

interface ILeaderboardStore {
	ladder: ReturnType<typeof fetchLeaderboardSuccess>["payload"];
	lastPayload: ReturnType<typeof fetchLeaderboard>["payload"] | null;
	requestState: RequestState;
	isVisibleUpdateNotice: boolean;
	profileRequestState: RequestState;
	_lastRequestedProfile: number | null;
	fetchedPages: number[];
	profiles: Record<number, IUserProfile>;
}

const defaultState: ILeaderboardStore = {
	ladder: {
		ranks: [],
		friendsParticipantsCount: 0,
		allParticipantsCount: 0,
		user: null,
		nextPage: false,
		updatedAt: "",
	},
	_lastRequestedProfile: null,
	lastPayload: null,
	profiles: {},
	fetchedPages: [],
	isVisibleUpdateNotice: false,
	requestState: RequestState.IDLE,
	profileRequestState: RequestState.IDLE,
};

export const leaderboards = createReducer({}, defaultState)
	.on(fetchLeaderboard, (state, payload) => ({
		...state,
		fetchedPages: uniq([...state.fetchedPages, payload.page]),
		requestState: RequestState.Requested,
		lastPayload: payload,
	}))
	.on(fetchLeaderboardSuccess, (state, payload) => ({
		...state,
		requestState: RequestState.Received,
		ladder: payload,
	}))
	.on(fetchLeadersFailed, () => ({
		...defaultState,
		requestState: RequestState.Received,
	}))
	.on(clearFetchedPagesLeaderboards, (state) => ({
		...state,
		fetchedPages: [],
		ladder: {
			...state.ladder,
			ranks: [],
		},
	}))
	.on(clearLeaderboard, (state) => ({
		...state,
		ladder: {
			ranks: [],
			friendsParticipantsCount: 0,
			allParticipantsCount: 0,
			user: null,
			nextPage: false,
			updatedAt: "",
		},
		fetchedPages: [],
	}))
	.on(fetchLeaderProfile, (state, payload) => ({
		...state,
		_lastRequestedProfile: payload.userId,
		profileRequestState: RequestState.Requested,
	}))
	.on(showUpdateNotice, (state, payload) => ({
		...state,
		isVisibleUpdateNotice: payload,
	}))
	.on(fetchLeaderProfileSuccess, (state, payload) => ({
		...state,
		_lastRequestedProfile: null,
		profiles: state._lastRequestedProfile
			? {
					...state.profiles,
					[state._lastRequestedProfile]: payload,
			  }
			: state.profiles,
		profileRequestState: RequestState.Received,
	}))
	.on(fetchLeaderProfileFailed, (state) => ({
		...state,
		_lastRequestedProfile: null,
		profileRequestState: RequestState.Error,
	}));
